<template>
  <ol v-if="content.children.length">
    <li
      class="term-box"
      v-for="(obj, index) of content.children"
    >
      <template v-if="obj.children.length">
        {{ parentIndexes[0] + 1 }}.{{ parentIndexes[1] + 1 }}:{{ index + 1 }}
        <div class="term">
          {{ obj.header[0].content }}
          <Depth5Point
            :parentIndexes="[...parentIndexes, index]"
            :content="obj"
          />
          <p v-if="obj.tail.length">{{ obj.tail[0].content }}</p>
        </div>
      </template>
      <template v-else>
        {{ parentIndexes[0] + 1 }}.{{ parentIndexes[1] + 1 }}:{{ index + 1 }}<p class="term">{{ obj.header[0].content }}</p>
      </template>
    </li>
  </ol>
</template>
<script>
import Depth5Point from './Depth5Point.vue'

export default {
  props: {
    content: Object,
    parentIndexes: Array,
  },
  components: {
    Depth5Point,
  },
}
</script>
<style lang="scss" scoped>
@import '../TermsOfUse.scss';
</style>
